import {createStore} from 'trim-redux'
const state = {
    app_name : "Kolay Doy",
    navCollapsed : false,
    isAuth : false,
    user : null,
    locale : "tr",
    features : [],
    primary_color:'#F0051F',
    secondary_color:'#489E21',
    error:'',
    setting:[],
    global_menu:'home',
    has_global_menu:true,
    selected_time:null,
    address_dialog:false,
    cart_loading:false,
    isApp:false,
};
export const store = createStore(state);